import { useConatextCategoriesData } from "@/Context/Categorie/ContextCategorieProvider";
import { useConatextMovilCategoriesData } from "@/Context/Categorie/ContextMovilCategories";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { lazy, Suspense, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
const LayoutHomeThree = lazy(
  () => import("@/Layout/HomeThree/LayoutHomeThree")
);
const DataFilter = lazy(
  () => import("@/Components/Filter/FilterData/DataFilter")
);
const DataView = lazy(() => import("@/Components/View/DataView"));

type paramSubCategory = { cteg?: string };

const PagePLP = () => {
  const { width } = useWindowsSize();
  const { cteg } = useParams<paramSubCategory>();
  const { MenuMovil, HeaddleActiveMenu } = useConatextMovilCategoriesData();
  const { VoidDefault, ProductsByCategory } = useConatextCategoriesData();

  useEffect(() => {
    VoidDefault(cteg!);
  }, [cteg]);

  return (
    <Suspense>
      <LayoutHomeThree toLink={"/Electrónicav2"} PLP={true}>
        {/*filtrar y vista en los dispositivos moviles*/}
        <div className="ps-panel--sidebar" id="navigation-mobile">
          <div className="ps-panel__header">
            <h3>Categories</h3>
          </div>
        </div>
        {/*web y movil */}
        <div className="ps-breadcrumb">
          <div className="ps-container">
            <ul className="breadcrumb">
              <li>
                <Link to={"/"}>Inicio</Link>
              </li>
              <li>
                <Link to={"/Electrónicav2"}>Electrónica</Link>
              </li>
              <li>{cteg?.replace(/-+/g, " ")}</li>
            </ul>
          </div>
        </div>
        <div className="ps-page--shop">
          <div className="ps-container">
            <div className="ps-shop-categories"></div>
            <div className="ps-layout--shop">
              <div className="ps-layout__left">
                <DataFilter />
              </div>
              <div className="ps-layout__right">
                <DataView />
              </div>
            </div>
          </div>
        </div>
        {width <= 1200 ? (
          <>
            <div className={`ps-filter--sidebar ${MenuMovil ? "active" : ""}`}>
              <div className="ps-filter__header">
                <h3>Filtrar Productos</h3>
                <Link
                  className="ps-btn--close ps-btn--no-boder"
                  to={""}
                  onClick={() => HeaddleActiveMenu(false)}></Link>
              </div>
              <div className="ps-filter__content">
                <div className="container">
                  <DataFilter />
                </div>
              </div>
            </div>
            <div className="ps-site-overlay"></div>
          </>
        ) : (
          ""
        )}
      </LayoutHomeThree>
    </Suspense>
  );
};

export default PagePLP;
